
import { defineComponent } from 'vue'
import { Select, ZoomIn, View, Hide } from '@element-plus/icons-vue'
import { ElImageViewer } from 'element-plus'
import { queryEmployeeSalaryBill, QueryEmployeeSalaryBillResult, queryUserWorkRecord } from '@/api/resume'

export default defineComponent({
    name: 'DrawerEmployeeDetail',
    components: {
        Select,
        ZoomIn,
        View,
        Hide,
        ElImageViewer
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        employeeData: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['update:show'],
    data() {
        return {
            showDrawer: true,
            activeTab: 'basic',
            employeeInfo: {} as any,
            maskedFields: {
                idCard: true,
                phone: true,
                bankCard: true
            },
            // 图片预览
            imageViewerVisible: false,
            previewImages: [] as string[],
            // 工作记录
            workMonth: this.getCurrentMonth(),
            workRecordList: [] as any[],
            // 发薪记录
            salaryMonth: this.getCurrentMonth(),
            salaryRecordList: [] as QueryEmployeeSalaryBillResult[]
        }
    },
    watch: {
        show: {
            handler(val) {
                this.showDrawer = val
                if (val) {
                    this.initData()
                }
            },
            immediate: true
        },
        showDrawer(val) {
            this.$emit('update:show', val)
        }
    },
    methods: {
        getCurrentMonth() {
            const date = new Date()
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            return `${year}-${month}`
        },
        formatListToString(list: any[]) {
            if (!list || !Array.isArray(list)) return '--'
            return list.map((item: any) => item.name || item.label || item).join('、')
        },
        initData() {
            this.activeTab = 'basic'
            this.workMonth = this.getCurrentMonth()
            this.salaryMonth = this.getCurrentMonth()
            // 如果传入了 employeeData，则使用传入的数据，否则使用默认测试数据
            if (this.employeeData && Object.keys(this.employeeData).length > 0) {
                // 映射来自 employment-management 的数据字段
                this.employeeInfo = {
                    workerName: this.employeeData.name || this.employeeData.workerName,
                    sex: this.employeeData.gender === 'female' ? '1' : '0',
                    age: this.employeeData.age,
                    location: this.employeeData.address || '--',
                    userHeadUrl: this.employeeData.userHeadUrl || '',
                    phone: this.employeeData.phone || '--',
                    idCardNo: this.employeeData.idCardNo,
                    bankCardNo: this.employeeData.bankCardNo,
                    bankCardImg: this.employeeData.bankCardImg,
                    healthCard: this.employeeData.healthCard,
                    idCardFront: this.employeeData.idCardFront,
                    idCardBack: this.employeeData.idCardBack,
                    userId: this.employeeData.userId,
                    workerTags: this.employeeData.labelList,
                    workPlace: this.formatListToString(this.employeeData.jobIntention?.workLocationList),
                    industry: this.formatListToString(this.employeeData.jobIntention?.intentionIndustryList),
                    workPeriod: this.formatListToString(this.employeeData.jobIntention?.workPeriodList)
                }
                this.getSalaryRecordList()
                this.getWorkRecordList()
            }
            console.log(this.employeeData, "00000000");

        },
        getLastChar(name: string) {
            if (!name) return ''
            return name.charAt(name.length - 1)
        },
        formatBankCard(bankCardNo: string) {
            if (!bankCardNo) return '--'
            return bankCardNo.replace(/(\d{4})(?=\d)/g, '$1 ')
        },
        formatPhone(phone: string) {
            if (!phone) return '--'
            return phone.replace(/(\d{3})\d+(\d{4})/, '$1****$2')
        },
        formatIdCard(idCardNo: string) {
            if (!idCardNo) return '--'
            return idCardNo.replace(/(\d{3})\d+(\d{4})/, '$1****$2')
        },
        formatBankCardMasked(bankCardNo: string) {
            if (!bankCardNo) return '--'
            return '**** **** **** ' + bankCardNo.slice(-4)
        },
        handleSalaryMonthChange() {
            this.getSalaryRecordList()
        },
        getWorkRecordList() {
            // 查询员工工作记录
            const month = this.formatMonth(this.workMonth)
            queryUserWorkRecord({ userId: this.employeeInfo.userId, queryMonth: month }).then((workRes: any) => {
                this.workRecordList = workRes.list || []
            }).catch((error: any) => {
                console.error('获取工作记录失败', error)
            })
        },
        getSalaryRecordList() {
            const month = this.formatMonth(this.salaryMonth)
            const params = {
                id: this.employeeData.id,
                queryMonth: month
            }
            queryEmployeeSalaryBill(params).then((res: any) => {
                this.salaryRecordList = res.list
            }).catch((error: any) => {
                console.error('获取发薪记录失败', error)
            })
        },
        handleViewIdCard() {
            const images = [this.employeeInfo.idCardFront, this.employeeInfo.idCardBack].filter(Boolean)
            if (images.length > 0) {
                this.previewImages = images
                this.imageViewerVisible = true
            }
        },
        handleViewBankCard() {
            if (this.employeeInfo.bankCardImg) {
                this.previewImages = [this.employeeInfo.bankCardImg]
                this.imageViewerVisible = true
            }
        },
        handleViewHealthCert() {
            if (this.employeeInfo.healthCard) {
                this.previewImages = [this.employeeInfo.healthCard]
                this.imageViewerVisible = true
            }
        },
        close() {
            this.showDrawer = false
        },
        handleCancel() {
            this.close()
        },
        handleConfirm() {
            console.log('确定')
            this.close()
        },
        handleWorkMonthChange() {
            this.getWorkRecordList()
        },
        formatMonth(date: Date | string) {
            if (typeof date === 'string') {
                return date
            }
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            return `${year}-${month}`
        },
        formatDateTime(dateString: string) {
            if (!dateString) return '--'
            const date = new Date(dateString)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            return `${year}-${month}-${day} ${hours}:${minutes}`
        }
    }
})
